module.exports = __webpack_public_path__ + "img/teams.058e7c37.jpg";